import { Layout } from '@denqfabrik/landing-ui';
import { type ReactNode, useState } from 'react';
import FunnelModal from '../FunnelModal';
import Footer from './Footer';
import Navbar from './Navbar';

export default function AppLayout({ children }: { children: ReactNode }) {
  // Lives here rather than inside Navbar so the overlay is a sibling of the page
  // content — a fixed child of a transformed/sticky header gets clipped.
  const [funnelOpen, setFunnelOpen] = useState(false);

  return (
    <>
      <Layout navbar={<Navbar onOpenFunnel={() => setFunnelOpen(true)} />} footer={<Footer />}>
        {children}
      </Layout>
      <FunnelModal open={funnelOpen} onClose={() => setFunnelOpen(false)} />
    </>
  );
}
